/**
 * @param root0
 * @param root0.app
 * @param root0.store
 */
export default async function ({ app, store }) {
  app.router.$previous = function (fallback_url) {
    if (store.getters["routing/PREVIOUS"]) app.router.go(-1)
    else app.router.replace(fallback_url || "/")
  }
}
